function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "super-admin");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter-1"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0.850000 0"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "super-admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  filter: "url(#filter-1)",
  id: "Shape-2"
}, React.createElement("g", {
  transform: "translate(76.000000, 0.000000)"
}, React.createElement("path", {
  d: "M536.799115,569.782857 C504.68099,579.611429 470.793646,585.142857 435.5,585.142857 C400.206354,585.142857 366.31901,579.611429 334.200885,569.782857 C227.412656,537.097143 106.720182,571.702857 44.3892448,665.005714 C16.3539323,706.971429 0,757.508571 0,811.885714 L0,914.285714 C0,974.88 48.7442448,1024 108.875,1024 L762.125,1024 C822.255755,1024 871,974.88 871,914.285714 L871,811.885714 C871,757.508571 854.646068,706.971429 826.610755,665.028571 C764.279818,571.725714 643.587344,537.097143 536.799115,569.782857 Z M762.125,914.285714 L108.875,914.285714 L108.875,811.885714 C108.875,728.594286 175.016562,660.571429 257.171823,658.331429 C315.011667,682.582857 374.983646,694.857143 435.5,694.857143 C495.993672,694.857143 555.965651,682.582857 613.828177,658.331429 C695.983437,660.571429 762.125,728.594286 762.125,811.885714 L762.125,914.285714 Z M435.5,512 C575.812656,512 689.541667,397.394286 689.541667,256 L689.541667,0 L562.520833,64 L435.5,0 L308.479167,64 L181.458333,0 L181.458333,256 C181.458333,397.394286 295.187344,512 435.5,512 Z M290.333333,219.428571 L580.666667,219.428571 L580.666667,256 C580.666667,336.662857 515.545807,402.285714 435.5,402.285714 C355.454193,402.285714 290.333333,336.662857 290.333333,256 L290.333333,219.428571 Z",
  id: "Shape",
  fill: "#595959",
  fillRule: "nonzero"
}))));

var SvgSuperAdmin = function SvgSuperAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSuperAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/super-admin.f0cd9ef6.svg";
export { ForwardRef as ReactComponent };